import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Task {
  showPricingModal: boolean;
  isPricingStep: boolean;
  isValidForm: boolean;
  isFormSubmitClicked: boolean;
}

const initialState: Task = {
  showPricingModal: false,
  isPricingStep: false,
  isValidForm: true,
  isFormSubmitClicked: false,
};

export const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setShowPricingModal: (state, action: PayloadAction<boolean>) => {
      state.showPricingModal = action.payload;
    },
    setIsPricingStep: (state, action: PayloadAction<boolean>) => {
      state.isPricingStep = action.payload;
    },
    setIsValidForm: (state, action: PayloadAction<boolean>) => {
      state.isValidForm = action.payload;
    },
    setIsFormSubmitClicked: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitClicked = action.payload;
    },
  },
});

export const {
  setShowPricingModal,
  setIsPricingStep,
  setIsValidForm,
  setIsFormSubmitClicked,
} = taskSlice.actions;

export default taskSlice.reducer;
